module.exports = __webpack_public_path__ + "img/boxed-5.5bd54b2b.jpg";